import React from 'react';
import { useTranslation } from 'react-i18next';
import {connect} from "react-redux";
import './index.css';
import {upperCaseFirstLetter} from "../../../../../../../../../../utils";

function ContactDetails (props) {

    const { t } = useTranslation();
    const {findContactDetails} = props;

    if(
        !findContactDetails.phoneContactEntry.note
        && !findContactDetails.phoneContactEntry.phoneNumbers
        && !findContactDetails.phoneContactEntry.emailAddresses
        && !findContactDetails.phoneContactEntry.postalAddresses
        && !findContactDetails.phoneContactEntry.birthday
    ){
        return (
            <div className="contact-details">
                <p className="mb-0"><em>{t("textNoContactDetails")}</em></p>
            </div>
        )
    } else {
        return (
            <div className="contact-details">
                {
                    findContactDetails.phoneContactEntry.note &&
                    <div className="d-flex">
                        <svg width="20" height="20" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                            <path fill="none" stroke="#314D60" strokeWidth="2" d="M6.417,2.792h11.166c1.104,0,2,0.895,2,2v14.416c0,1.104-0.896,2-2,2H6.417
                            c-1.104,0-2-0.896-2-2V4.792C4.417,3.687,5.313,2.792,6.417,2.792z"/>
                            <path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round" d="M8.75,8.208h6.5"/>
                            <path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round" d="M8.75,12.542h6.5"/>
                            <path fill="none" stroke="#314D60" strokeWidth="2" strokeLinecap="round" d="M8.75,16.874h4.334"/>
                        </svg>
                        <p className="pl-3">{findContactDetails.phoneContactEntry.note}</p>
                    </div>
                }
                {
                    findContactDetails.phoneContactEntry.phoneNumbers &&
                    <div className="phone-numbers">
                        {
                            findContactDetails.phoneContactEntry.phoneNumbers.map((phoneNumber, index) => (
                                <div key={index} className="d-flex phone-number">
                                    <svg width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="none" d="M0 0h24v24H0V0z"/>
                                        <path
                                            d="M6.54 5c.06.89.21 1.76.45 2.59l-1.2 1.2c-.41-1.2-.67-2.47-.76-3.79h1.51m9.86 12.02c.85.24 1.72.39 2.6.45v1.49c-1.32-.09-2.59-.35-3.8-.75l1.2-1.19M7.5 3H4c-.55 0-1 .45-1 1 0 9.39 7.61 17 17 17 .55 0 1-.45 1-1v-3.49c0-.55-.45-1-1-1-1.24 0-2.45-.2-3.57-.57-.1-.04-.21-.05-.31-.05-.26 0-.51.1-.71.29l-2.2 2.2c-2.83-1.45-5.15-3.76-6.59-6.59l2.2-2.2c.28-.28.36-.67.25-1.02C8.7 6.45 8.5 5.25 8.5 4c0-.55-.45-1-1-1z"/>
                                    </svg>
                                    <p className="pl-3"><a href={"tel:" + phoneNumber.number} target="_blank" rel="noreferrer">{phoneNumber.number}</a> {phoneNumber.label ? <span className="field-type">• {upperCaseFirstLetter(phoneNumber.label)}</span> : ''}</p>
                                </div>
                            ))
                        }
                    </div>
                }
                {
                    findContactDetails.phoneContactEntry.emailAddresses &&
                    <div className="email-addresses">
                        {
                            findContactDetails.phoneContactEntry.emailAddresses.map((emailAddress, index) => (
                                <div key={index} className="d-flex email-address">
                                    <svg width="20" height="20" viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg">
                                        <path d="M0 0h24v24H0V0z" fill="none"/>
                                        <path
                                            d="M22 6c0-1.1-.9-2-2-2H4c-1.1 0-2 .9-2 2v12c0 1.1.9 2 2 2h16c1.1 0 2-.9 2-2V6zm-2 0l-8 5-8-5h16zm0 12H4V8l8 5 8-5v10z"/>
                                    </svg>
                                    <p className="pl-3"><a href={"mailto:" + emailAddress.email} target="_blank" rel="noreferrer">{emailAddress.email}</a> {emailAddress.label ? <span className="field-type">• {upperCaseFirstLetter(emailAddress.label)}</span> : ''}</p>
                                </div>
                            ))
                        }
                    </div>
                }
                {
                    findContactDetails.phoneContactEntry.postalAddresses &&
                    <div className="postal-addresses">
                        {
                            findContactDetails.phoneContactEntry.postalAddresses.map((postalAddress, index) => (
                                <div key={index} className="d-flex postal-address">
                                    <svg width="20" height="20" viewBox="0 0 24 24">
                                        <path fill="none" d="M0 0h24v24H0V0z"/>
                                        <path
                                            fill="#314D60"
                                            d="M12 2C8.13 2 5 5.13 5 9c0 5.25 7 13 7 13s7-7.75 7-13c0-3.87-3.13-7-7-7zM7 9c0-2.76 2.24-5 5-5s5 2.24 5 5c0 2.88-2.88 7.19-5 9.88C9.92 16.21 7 11.85 7 9z"/>
                                        <circle cx="12" cy="9" r="2.5"/>
                                    </svg>
                                    <ul className="list-unstyled pl-3">
                                        <li>{postalAddress.street}</li>
                                        <li>{postalAddress.postCode}</li>
                                        <li>{postalAddress.city}</li>
                                        <li>{postalAddress.label}</li>
                                        <li>{postalAddress.state}</li>
                                        <li>{postalAddress.country}</li>
                                    </ul>
                                </div>
                            ))
                        }
                    </div>
                }
                {
                    findContactDetails.phoneContactEntry.birthday &&
                    <div className="d-flex">
                        <svg width="20" height="20" viewBox="0 0 24 24">
                            <path d="M0 0h24v24H0V0z" fill="none"/>
                            <path
                                fill="#314D60"
                                d="M19 14v-4c0-1.1-.9-2-2-2h-4V6.55c.15-.09.29-.18.41-.31.39-.39.59-.92.59-1.42s-.2-1.02-.59-1.41L12 2l-1.41 1.41c-.39.39-.59.91-.59 1.41s.2 1.03.59 1.42c.13.13.27.22.41.31V8H7c-1.1 0-2 .9-2 2v4c-1.1 0-2 .9-2 2v4c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-4c0-1.1-.9-2-2-2zM7 10h10v4H7v-4zm12 10H5v-4h14v4z"/>
                        </svg>
                        <p className="pl-3">{`
                            ${
                                findContactDetails.phoneContactEntry.birthday.month > 9
                                    ?
                                    findContactDetails.phoneContactEntry.birthday.month
                                    :
                                    '0' + findContactDetails.phoneContactEntry.birthday.month
                            }
                            /
                            ${
                                findContactDetails.phoneContactEntry.birthday.day > 9
                                    ?
                                    findContactDetails.phoneContactEntry.birthday.day
                                    :
                                    '0' + findContactDetails.phoneContactEntry.birthday.day
                            }
                            /
                            ${
                                findContactDetails.phoneContactEntry.birthday.year
                            }
                        `}</p>
                    </div>
                }
            </div>
        )
    }

}

const mapStateToProps = (state) => {
    return {
        findContactDetails: state.contactDetailsReducer.findContactDetails,
    }
};

export default connect(mapStateToProps)(ContactDetails);
